export default Object.freeze({
  UNSET: null,
  CONTRACT_HISTORY: 1,
});
